// @flow
import React, { useEffect, useRef } from 'react';

const normalizeValue = (value: ?string) => value && String(value);

type Props = $ReadOnly<{
    value: ?string,
    disabled?: boolean,
    Component?: string,

    onFocus: (e: SyntheticFocusEvent) => void,
    onBlur: (e: SyntheticEvent) => void,
    onKeyDown: (e: SyntheticKeyboardEvent) => void,
    onChange: (e: SyntheticEvent) => void,
}>;

export default React.forwardRef(function ContentEditable({ value, disabled, Component = 'div', onFocus, onBlur, onKeyDown, onChange }: Props, ref) {
    const innerRef = useRef();
    const previousHtml = useRef();

    const getRef = (element) => {
        innerRef.current = element;

        if(ref) {
            if(typeof ref === 'function') {
                ref(element);
            }
            else {
                ref.current = element;
            }
        }
    };

    const handleKeyUp = (e) => {
        const html = innerRef.current.innerHTML;

        if(onChange && innerRef.current && html !== previousHtml.current) {
            const event = {
                ...e,
                target: {
                    value: html
                }
            };

            onChange(event);
        }

        previousHtml.current = html;
    };

    useEffect(() => {
        if(innerRef.current) {
            const _value = normalizeValue(value);
            if(_value !== previousHtml.current) {
                innerRef.current.innerHTML = previousHtml.current = _value;
            }
        }
    }, [value]);

    return (
        <Component
            ref={getRef}
            contentEditable={!disabled}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onKeyUp={handleKeyUp}
            onChange={onChange}
        />
    )
});